import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const API = ""; // same-origin now — Vercel rewrites /api/* to the backend (see client/vercel.json). Keeps the session cookie first-party for Safari/Firefox.

// ─── PLAN DATA ───
const PLANS = [
  {
    key: "free",
    icon: "🆓",
    name: "FREE",
    price: "₹0",
    period: "Forever",
    color: "#aaa",
    border: "#444",
    glow: "rgba(180,180,180,0.18)",
    btnBg: "#2a2a2a",
    btnColor: "#aaa",
    btnText: "Current Plan",
    img: "/images/free-char.png",
    features: [
      { ok: true,  text: "Subtitle Editor" },
      { ok: true,  text: "1 Free Translation / Ad" },
      { ok: false, text: "API Key Support" },
      { ok: false, text: "Ad-Free" },
    ],
  },
  {
    key: "pro",
    icon: "⚡",
    name: "PRO",
    price: "₹20",
    period: "/ 10 days",
    color: "#FF6B00",
    border: "#FF6B00",
    glow: "rgba(255,107,0,0.28)",
    btnBg: "linear-gradient(135deg,#FF6B00,#e05500)",
    btnColor: "#fff",
    btnText: "Buy Pro — ₹20",
    img: "/images/pro-char.png",
    badge: "Popular",
    badgeColor: "#FF6B00",
    features: [
      { ok: true, text: "Subtitle Editor" },
      { ok: true, text: "AI Translation" },
      { ok: true, text: "Apna API Key (Gemini/OpenAI)" },
      { ok: false, text: "Ads dikhenge" },
    ],
  },
  {
    key: "ultra_pro",
    icon: "🌟",
    name: "ULTRA PRO",
    price: "₹100",
    period: "/ 60 days",
    color: "#00BFFF",
    border: "#00BFFF",
    glow: "rgba(0,191,255,0.28)",
    btnBg: "linear-gradient(135deg,#00BFFF,#0077cc)",
    btnColor: "#fff",
    btnText: "Buy Ultra Pro — ₹100",
    img: "/images/ultra-char.png",
    badge: "Best Value",
    badgeColor: "#00BFFF",
    save: "💰 Save ₹20 vs Pro!",
    features: [
      { ok: true, text: "Subtitle Editor" },
      { ok: true, text: "AI Translation" },
      { ok: true, text: "Apna API Key (Gemini/OpenAI)" },
      { ok: true, text: "Live Translate View" },
      { ok: true, text: "100% Ad-Free" },
    ],
  },
];

function AdBanner({ onClose }) {
  return (
    <div style={{
      background: "linear-gradient(135deg, #1a1a2e, #16213e)",
      border: "1px solid #2a2a4a",
      borderRadius: 10,
      padding: "10px 16px",
      margin: "0 16px 16px 16px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between"
    }}>
      <div>
        <span style={{ color: "#555", fontSize: 9, textTransform: "uppercase", letterSpacing: 1 }}>Advertisement</span>
        <p style={{ color: "#aaa", margin: "2px 0 0 0", fontSize: 13 }}>
          🌟 Upgrade to Ultra Pro — Ad-Free experience ke liye!
        </p>
      </div>
      <span onClick={onClose} style={{ color: "#FF6B00", fontSize: 18, cursor: "pointer", padding: "0 4px" }}>✕</span>
    </div>
  );
}

export default function Premium() {
  const navigate = useNavigate();
  const [profile, setProfile] = useState(null);
  const [adVisible, setAdVisible] = useState(true);
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(1); // 0=free, 1=pro, 2=ultra_pro
  const token = localStorage.getItem("subai_session"); // non-sensitive "am I logged in" flag now — real session is the httpOnly cookie

  useEffect(() => {
    fetch(`${API}/api/profile`, {
      headers: { Authorization: "Bearer " + token }
    }).then(r => r.json()).then(d => setProfile(d)).catch(() => {});
  }, []);

  // Touch / swipe support
  const [touchStart, setTouchStart] = useState(null);
  const onTouchStart = (e) => setTouchStart(e.touches[0].clientX);
  const onTouchEnd = (e) => {
    if (touchStart === null) return;
    const diff = touchStart - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      if (diff > 0) setActive(a => Math.min(a + 1, 2)); // swipe left → next
      else          setActive(a => Math.max(a - 1, 0)); // swipe right → prev
    }
    setTouchStart(null);
  };

  const buyPlan = async (plan) => {
    if (!token) { navigate("/"); return; }
    if (plan === "free") return;
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/payment/create-order`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
        body: JSON.stringify({ plan })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.message);

      const keyRes = await fetch(`${API}/api/get-key`);
      const { key } = await keyRes.json();

      const options = {
        key,
        amount: data.amount,
        currency: "INR",
        name: "SubtitleAI",
        description: plan === "ultra_pro" ? "Ultra Pro Plan" : "Pro Plan",
        order_id: data.orderId,
        handler: async (response) => {
          try {
            const verifyRes = await fetch(`${API}/api/payment/verify`, {
              method: "POST",
              headers: { "Content-Type": "application/json", Authorization: "Bearer " + token },
              body: JSON.stringify({
                paymentId: response.razorpay_payment_id,
                orderId:   response.razorpay_order_id,
                signature: response.razorpay_signature,
                plan
              })
            });
            const vData = await verifyRes.json();
            if (!verifyRes.ok) {
              alert("❌ Payment verify nahi ho saka: " + (vData.message || "Unknown error"));
              return;
            }
            alert("✅ " + vData.message);
            window.location.href = "/dashboard";
          } catch (verifyErr) {
            alert("❌ Payment verification mein network error aaya. Support se contact karo.");
          }
        },
        prefill: { name: profile?.name, email: profile?.email },
        theme: { color: plan === "ultra_pro" ? "#00BFFF" : "#FF6B00" }
      };
      if (!window.Razorpay) {
        alert("❌ Razorpay load nahi hua. Page refresh karo aur dubara try karo.");
        return;
      }
      new window.Razorpay(options).open();
    } catch (err) {
      const msg = err.message || "Payment shuru nahi ho saka";
      alert("❌ " + msg);
      console.error("[Payment] Error:", err);
    } finally {
      setLoading(false);
    }
  };

  const isActive = (p) => profile?.plan === p && profile?.planActive;
  const expStr   = (d) => d ? new Date(d).toLocaleDateString("en-IN") : "";

  // position: -1 = left, 0 = center, 1 = right
  const getPos = (i) => i - active;

  return (
    <div style={styles.page}>

      {/* ── NAVBAR ── */}
      <div style={styles.navbar}>
        <button onClick={() => navigate("/dashboard")} style={styles.backBtn}>←</button>
        <span style={styles.navTitle}>💎 Choose Plan</span>
        <div style={{ width: 36 }} />
      </div>

      {/* ── CURRENT PLAN ── */}
      {/* Ad Banner */}
      {adVisible && profile?.showAds && (
        <AdBanner onClose={() => setAdVisible(false)} />
      )}

      {profile && (
        <p style={styles.currentInfo}>
          Current: <b style={{ color: "#FF6B00" }}>{profile.plan === "ultra_pro" ? "Ultra Pro" : profile.plan === "pro" ? "Pro" : "Free"}</b>
          {profile.planExpiry && profile.planActive && (
            <span style={{ color: "#00C896", marginLeft: 6 }}>• expires {expStr(profile.planExpiry)}</span>
          )}
          {profile.plan === "free" && (
            <span style={{ color: "#00BFFF", marginLeft: 6 }}>
              • 💎 {profile.adCredits || 0} ad-credit{profile.adCredits === 1 ? "" : "s"} banked
            </span>
          )}
        </p>
      )}

      {/* ── SLIDE CARDS ── */}
      <div
        style={styles.stage}
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
      >
        {PLANS.map((plan, i) => {
          const pos    = getPos(i);       // -1, 0, 1
          const center = pos === 0;
          const gone   = Math.abs(pos) > 1;

          const tx     = pos * 82;        // % shift
          const scale  = center ? 1 : 0.78;
          const op     = gone ? 0 : center ? 1 : 0.55;
          const zi     = center ? 10 : 5 - Math.abs(pos);

          return (
            <div
              key={plan.key}
              onClick={() => !center && setActive(i)}
              style={{
                ...styles.card,
                borderColor: center ? plan.border : "#2a2a2a",
                boxShadow: center
                  ? `0 0 40px ${plan.glow}, 0 0 0 2px ${plan.border}44`
                  : "none",
                transform: `translateX(${tx}%) scale(${scale})`,
                opacity: op,
                zIndex: zi,
                pointerEvents: gone ? "none" : "auto",
                cursor: center ? "default" : "pointer",
              }}
            >
              {/* Character image */}
              <div style={styles.imgWrap}>
                <img
                  src={plan.img}
                  alt={plan.name}
                  style={styles.charImg}
                  onError={e => { e.target.style.display = "none"; }}
                />
                {/* Gradient overlay so text is readable */}
                <div style={styles.imgOverlay} />
              </div>

              {/* Badge */}
              {plan.badge && (
                <div style={{ ...styles.badge, background: plan.badgeColor }}>
                  {plan.key === "ultra_pro" && "👑 "}{plan.badge}
                </div>
              )}

              {/* Content */}
              <div style={styles.cardBody}>
                <h2 style={{ ...styles.planName, color: plan.color }}>{plan.name}</h2>
                <div style={styles.priceRow}>
                  <span style={{ ...styles.price, color: plan.color }}>{plan.price}</span>
                  <span style={styles.period}>{plan.period}</span>
                </div>
                {plan.save && <div style={styles.saveTag}>{plan.save}</div>}

                <ul style={styles.feats}>
                  {plan.features.map((f, j) => (
                    <li key={j} style={{ ...styles.featItem, color: f.ok ? "#ddd" : "#444" }}>
                      <span style={{ color: f.ok ? plan.color : "#333", fontSize: 14 }}>
                        {f.ok ? "✓" : "✕"}
                      </span>
                      {f.text}
                    </li>
                  ))}
                </ul>

                {/* CTA Button */}
                <button
                  onClick={(e) => { e.stopPropagation(); buyPlan(plan.key); }}
                  disabled={loading || isActive(plan.key) || plan.key === "free"}
                  style={{
                    ...styles.btn,
                    background: isActive(plan.key)
                      ? "#1e1e1e"
                      : plan.btnBg,
                    color: isActive(plan.key) ? "#00C896" : plan.btnColor,
                    border: isActive(plan.key) ? "1px solid #00C89655" : "none",
                    opacity: (loading || plan.key === "free") ? 0.7 : 1,
                    cursor: plan.key === "free" ? "default" : "pointer",
                  }}
                >
                  {isActive(plan.key) ? "✅ Active" : plan.btnText}
                </button>
              </div>
            </div>
          );
        })}
      </div>

      {/* ── DOTS ── */}
      <div style={styles.dots}>
        {PLANS.map((_, i) => (
          <div
            key={i}
            onClick={() => setActive(i)}
            style={{
              ...styles.dot,
              width: active === i ? 24 : 8,
              background: active === i ? PLANS[i].color : "#333",
            }}
          />
        ))}
      </div>

      {/* ── FOOTER NOTE ── */}
      <p style={styles.footer}>
        🔒 Secure payment via Razorpay • Apna API key use hota hai, hum store nahi karte
      </p>

      {/* ── INLINE CSS for spin animation ── */}
      <style>{`
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "#08080F",
    color: "#E8E8E8",
    fontFamily: "sans-serif",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    overflow: "hidden",
  },

  navbar: {
    width: "100%",
    display: "flex", alignItems: "center", justifyContent: "space-between",
    padding: "14px 16px",
    borderBottom: "1px solid #1a1a1a",
  },
  backBtn: {
    background: "none", border: "1px solid #2a2a2a",
    color: "#aaa", width: 36, height: 36,
    borderRadius: 10, cursor: "pointer", fontSize: 18,
    display: "flex", alignItems: "center", justifyContent: "center",
  },
  navTitle: { fontSize: 16, fontWeight: 700 },

  currentInfo: {
    color: "#666", fontSize: 13,
    margin: "12px 0 0 0", textAlign: "center",
  },

  /* ── STAGE ── */
  stage: {
    position: "relative",
    width: "100%",
    height: 560,
    marginTop: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  card: {
    position: "absolute",
    width: "72vw",
    maxWidth: 300,
    background: "#0f0f1a",
    border: "1px solid #2a2a2a",
    borderRadius: 24,
    overflow: "hidden",
    transition: "all 0.4s cubic-bezier(0.4,0,0.2,1)",
    flexShrink: 0,
  },

  imgWrap: {
    width: "100%",
    height: 200,
    position: "relative",
    overflow: "hidden",
    background: "#0a0a14",
  },
  charImg: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "top center",
  },
  imgOverlay: {
    position: "absolute",
    bottom: 0, left: 0, right: 0,
    height: "55%",
    background: "linear-gradient(to bottom, transparent, #0f0f1a)",
  },

  badge: {
    position: "absolute",
    top: 12, right: 12,
    color: "#fff",
    fontSize: 10, fontWeight: 800,
    padding: "4px 10px",
    borderRadius: 20,
    letterSpacing: 0.5,
    zIndex: 5,
  },

  cardBody: {
    padding: "14px 18px 20px 18px",
  },
  planName: {
    fontSize: 22, fontWeight: 900,
    margin: "0 0 6px 0",
    letterSpacing: 1,
  },
  priceRow: {
    display: "flex", alignItems: "baseline", gap: 6,
    marginBottom: 6,
  },
  price: {
    fontSize: 32, fontWeight: 900,
    lineHeight: 1,
  },
  period: {
    color: "#555", fontSize: 13,
  },
  saveTag: {
    color: "#00C896",
    fontSize: 12, fontWeight: 700,
    marginBottom: 10,
  },

  feats: {
    listStyle: "none", padding: 0, margin: "0 0 16px 0",
    display: "flex", flexDirection: "column", gap: 7,
  },
  featItem: {
    fontSize: 13,
    display: "flex", alignItems: "center", gap: 8,
  },

  btn: {
    width: "100%", padding: "13px",
    borderRadius: 12,
    fontSize: 14, fontWeight: 800,
    transition: "opacity 0.2s",
    letterSpacing: 0.3,
  },

  dots: {
    display: "flex", gap: 6, alignItems: "center",
    marginTop: 12,
  },
  dot: {
    height: 8, borderRadius: 4,
    transition: "all 0.3s ease",
    cursor: "pointer",
  },

  footer: {
    color: "#333", fontSize: 11,
    textAlign: "center",
    padding: "16px 20px 30px 20px",
    maxWidth: 340,
    lineHeight: 1.6,
  },
};
